import { render, staticRenderFns } from "./McrAvgDuration.vue?vue&type=template&id=3e47d65c&scoped=true"
import script from "./McrAvgDuration.vue?vue&type=script&lang=js"
export * from "./McrAvgDuration.vue?vue&type=script&lang=js"
import style0 from "./McrAvgDuration.vue?vue&type=style&index=0&id=3e47d65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47d65c",
  null
  
)

export default component.exports